import React from "react";

import { useTranslation } from "react-i18next";
import moment from "moment";

import { Lesson } from "types";
import { RibbonWrapper, RibbonContent } from "./CornerRibbonStyles";

type TProps = {
  lesson: Lesson;
  showRibbon: {
    past: boolean;
    completed: boolean;
    rated: boolean;
  };
};
const CardRibbon = ({
  lesson: { completed, rated, startTime },
  showRibbon,
}: TProps) => {
  const { t } = useTranslation("class_card");

  const renderCompletedRibbon = () => (
    <RibbonWrapper>
      <RibbonContent>{t("FINISHED")}</RibbonContent>
    </RibbonWrapper>
  );
  const renderRatedRibbon = () => (
    <RibbonWrapper>
      <RibbonContent>{t("RATED")}</RibbonContent>
    </RibbonWrapper>
  );

  const renderPastRibbon = () => (
    <RibbonWrapper>
      <RibbonContent>{t("PAST")}</RibbonContent>
    </RibbonWrapper>
  );

  const showRatedRibbon = showRibbon.rated && rated;
  const showCompletedRibbon =
    showRibbon.completed && completed && !showRatedRibbon;
  const showPastRibbon =
    showRibbon.past &&
    moment().isAfter(moment(startTime)) &&
    !showRatedRibbon &&
    !showCompletedRibbon;

  if (showRatedRibbon) return renderRatedRibbon();
  if (showCompletedRibbon) return renderCompletedRibbon();
  if (showPastRibbon) return renderPastRibbon();

  return null;
};

export default CardRibbon;
